<template>
  <div
    class="error-triangle-container"
    :style="{
      width: '24px', // for performance, keep div 24px wide, and only render icon and tooltip when needed
      'pointer-events': displayErrorMessage ? 'auto' : 'none',
    }"
  >
    <v-tooltip v-if="displayErrorMessage" :content-class="contentClass" :location="tooltipLocation">
      <template #activator="{ props: tooltipProps }">
        <i
          :class="{ small, 'material-icons-round': round }"
          class="material-icons error-triangle"
          v-bind="tooltipProps"
          >{{ iconType }}</i
        >
      </template>
      <span>{{ errorMessage }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { reduce } from 'lodash';

export default {
  props: {
    errors: {
      required: true,
      type: Object,
    },
    serverError: {
      required: false,
      type: String,
      default: () => '',
    },
    iconType: {
      required: false,
      type: String,
      default: () => 'warning',
    },
    small: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    round: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    arrow: {
      required: false,
      type: Boolean,
      default: () => true,
    },
    tooltipLocation: {
      required: false,
      type: String,
      default: 'end',
    },
  },
  computed: {
    errorMessage() {
      const localErrorMsg = reduce(
        this.errors,
        (result, value, key) => (!value ? key : result),
        ''
      );
      const serverErrorMsg = this.serverError;
      return localErrorMsg || serverErrorMsg;
    },
    displayErrorMessage() {
      return !!this.errorMessage;
    },
    contentClass() {
      return `rtls-tooltip ${this.arrow ? '' : 'no-arrow'}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.error-triangle-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-triangle {
  color: $rtls-negative-action-colour;
}
.small {
  font-size: 2rem !important;
}
</style>
